import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { FamilyPlanTypes } from '../../common/services/package/package.model';


import { OpenAboutDialogAction } from './family-plan-about-dialog.action';


/* @ngInject */
export default class OpenAboutDialogController implements ActionHandler {
  private dialogElement;
  private type: FamilyPlanTypes;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-about-dialog').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenAboutDialogAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onClose() {
    this.dialogElement.close();
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-about-dialog/family-plan-about-dialog.controller.ts